import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App.tsx';

// Import Tailwind CSS
import './styles/tailwind.css';

// Render the main app
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
